import React from 'react';
import { Id } from '../types/Id';
import {
  ExpansionControlProps,
  RibbonListProps,
  UseExpansionReturnValue,
} from '../types/StackedRibbonListComponentTypes';

// RibbonListWrapper uses the useExpansion hook internally so that's why this context has access to
// expansion-related functions via the `UseExpansionReturnValue`.
export interface RibbonListExpansionContextType<TId extends Id, TItem>
  extends Pick<UseExpansionReturnValue<TId>, 'isIdExpanded' | 'toggleExpansion'>,
    Pick<ExpansionControlProps<TId>, 'isExpandable' | 'hideExpansionDisclosure'>,
    Pick<RibbonListProps<TId, TItem>, 'expandableContent'> {}

export const RibbonListExpansionContext = React.createContext(
  {} as RibbonListExpansionContextType<Id, unknown>,
);
